function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// update ../../main/scss/vars.scss when changing this file
var fontFamily = {
  fontFamily: 'Artifakt Element, sans-serif'
};
export default {
  hero: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '48px',
    lineHeight: '64px'
  }),
  title: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '30px',
    lineHeight: '42px'
  }),
  heading1: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '30px'
  }),
  heading2: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '26px'
  }),
  heading3: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  heading4: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  heading5: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  bodyLarge: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  bodyLargeBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  bodyMedium: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  bodyMediumBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  bodySmall: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  bodySmallBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  labelMedium: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  labelSmall: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  caption: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px'
  }),
  captionBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '15px'
  }),
  eyebrow: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '15px',
    letterSpacing: 0.5,
    textTransform: 'uppercase'
  }),
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  lineClamp: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  }
};
//# sourceMappingURL=typography.js.map